/*
    Usage:
        const queryParams = new QueryPArams()
        queryParams.addParam('view', 'enrolled')
        const url = 'google.com' + queryParams.toString()
*/
class QueryParams {
    constructor () {
        this.params = []
    }
    addValue (key, value) {
        this.params.push(`${key}=${value}`)
    }

    addParam (key, value, valueMutator = d => d ) {
        if (!key || value === undefined || value === null || value === '') {
            return null
        }

        if (Array.isArray(value)) {
            value.forEach(v => {
                this.addValue(key, valueMutator(v))
            })
        } else {
            this.addValue(key, valueMutator(value))
        }
    }
    toString () {
        const queryString = this.params.join('&')
        return queryString ? `?${queryString}` : ''
    }
}

export default QueryParams